<div class="w-h-image-preview-header p--4 flex--r-c-sb">
  <span class="flex--r-c gap--4">
    <mat-icon color="primary">image</mat-icon>
    <span class="file-meta-data">
      {{ data.image.fileName }}{{ data.image.extension }}
    </span>
  </span>

  <span>
    <button
      (click)="downloadImageFile()"
      (keydown.enter)="downloadImageFile()"
      mat-icon-button
    >
      <mat-icon color="accent">download</mat-icon>
    </button>

    <button
      (keydown.enter)="closeDialog()"
      (click)="closeDialog()"
      mat-icon-button
    >
      <mat-icon color="accent">close</mat-icon>
    </button>
  </span>
</div>
<div style="height: 80vh" class="flex--r-c-c">
  <img
    class="image-preview"
    alt="preview"
    style="width: 100%; height: 100%; object-fit: contain"
    *ngIf="data.image.file | WHImgAuthHeader | async as image; else loading"
    [src]="image"
  />

  <ng-template #loading>
    <!-- Loading... -->
    <div style="text-align: center">
      <mat-spinner [diameter]="20" style="display: inline-block"></mat-spinner>
    </div>
  </ng-template>
</div>
